"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  var _theme$useToken = _antd.theme.useToken(),
    token = _theme$useToken.token;
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: 'vertical'
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "magenta"
  }, "magenta"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "red"
  }, "red"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "volcano"
  }, "volcano"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "orange"
  }, "orange"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "gold"
  }, "gold"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "lime"
  }, "lime"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "green"
  }, "green"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "cyan"
  }, "cyan"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "blue"
  }, "blue"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "geekblue"
  }, "geekblue"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "purple"
  }, "purple")), /*#__PURE__*/_react.default.createElement(_antd.Divider, null), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      background: token.colorFillSecondary,
      padding: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "magenta"
  }, "magenta"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "red"
  }, "red"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "volcano"
  }, "volcano"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "orange"
  }, "orange"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "gold"
  }, "gold"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "lime"
  }, "lime"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "green"
  }, "green"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "cyan"
  }, "cyan"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "blue"
  }, "blue"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "geekblue"
  }, "geekblue"), /*#__PURE__*/_react.default.createElement(_antd.Tag, {
    color: "purple"
  }, "purple")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['blue-1', 'blue-3', 'blue-6', 'blue-7', 'cyan-1', 'cyan-3', 'cyan-6', 'cyan-7', 'geekblue-1', 'geekblue-3', 'geekblue-6', 'geekblue-7', 'gold-1', 'gold-3', 'gold-6', 'gold-7', 'green-1', 'green-3', 'green-6', 'green-7', 'lime-1', 'lime-3', 'lime-6', 'lime-7', 'magenta-1', 'magenta-3', 'magenta-6', 'magenta-7', 'orange-1', 'orange-3', 'orange-6', 'orange-7', 'pink-1', 'pink-3', 'pink-6', 'pink-7', 'purple-1', 'purple-3', 'purple-6', 'purple-7', 'volcano-1', 'volcano-3', 'volcano-6', 'volcano-7', 'yellow-1', 'yellow-3', 'yellow-6', 'yellow-7', 'red-1', 'red-3', 'red-6', 'red-7'],
  key: 'default'
};
var _default = exports.default = componentDemo;